import React from 'react';
import styled from 'styled-components';
import Tooltip from './Tooltip';
interface Props {
    label: string;
    tooltip?: string;
}
interface S {
    tooltip?: string;
}

const LabelText = styled.span`
    margin-right: 5px;
    user-select: none;
    font-size: 16px;
    font-weight: 600;
`;

const LabelContainer = styled.div`
    display: flex;
    align-items: center;
`;

export const Label: React.FC<Props> = ({ label, tooltip }: Props) => {
    return (
        <LabelContainer>
            <LabelText>{label}</LabelText>

            {tooltip && <Tooltip text={tooltip} />}
        </LabelContainer>
    );
};

export default Label;
